export const PARTNER_BOOKINGS_AVAILABILITY_API = 'v1/partner-bookings/availability';

export interface GetRequestQuery {
  venueId: string;
  /** Venue-local, YYYY-MM-DD. */
  date: string;
}

export type NotBookableReason =
  | 'NOT_LIVE'
  | 'NOT_CONNECTED'
  | 'ACCOUNT_NOT_VERIFIED'
  | 'NO_RATES'
  | 'UNSUPPORTED_SYSTEM'
  | 'OUTSIDE_WINDOW'
  | 'NO_TIMEZONE';

export interface AvailabilityFreeSpan {
  /** Venue-local, HH:mm. */
  startLocal: string;
  endLocal: string;
}

export interface AvailabilityCourtPayload {
  providerResourceId: string;
  providerCourtId: string | null;
  name: string;
  /** Lowest hourly rate the club charges here, cents; null until the club has a price source. */
  fromPriceUnitAmount: number | null;
  currency: string;
  /** Free time on the club's system minus our open holds, ascending, non-overlapping. */
  free: AvailabilityFreeSpan[];
}

export interface GetResponsePayload {
  venueId: string;
  date: string;
  timezone: string;
  isBookable: boolean;
  notBookableReason: NotBookableReason | null;
  maxAdvanceBookingDays: number | null;
  /** Last venue-local date a player may book, or null when the club sets no window. */
  lastBookableDate: string | null;
  slotMinutes: number;
  minDurationMinutes: number;
  /** Weekdays the club takes Bounce bookings (`MONDAY`…); null when it sets no hours. */
  bookableDays: string[] | null;
  /** "Mon–Fri 9:00am–5:00pm"; null when it sets no hours. */
  bookableHoursLabel: string | null;
  courts: AvailabilityCourtPayload[];
}
